import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLevels = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.0392 4.095C8.89386 4.095 9.5867 3.40216 9.5867 2.5475C9.5867 1.69284 8.89386 1 8.0392 1C7.18454 1 6.4917 1.69284 6.4917 2.5475C6.4917 3.40216 7.18454 4.095 8.0392 4.095Z",
			stroke: "#525059",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.881 13.38C3.73566 13.38 4.4285 12.6871 4.4285 11.8325C4.4285 10.9778 3.73566 10.285 2.881 10.285C2.02634 10.285 1.3335 10.9778 1.3335 11.8325C1.3335 12.6871 2.02634 13.38 2.881 13.38Z",
			stroke: "#525059",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.0392 13.38C8.89386 13.38 9.5867 12.6871 9.5867 11.8325C9.5867 10.9778 8.89386 10.285 8.0392 10.285C7.18454 10.285 6.4917 10.9778 6.4917 11.8325C6.4917 12.6871 7.18454 13.38 8.0392 13.38Z",
			stroke: "#525059",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1979 13.38C14.0526 13.38 14.7454 12.6871 14.7454 11.8325C14.7454 10.9778 14.0526 10.285 13.1979 10.285C12.3432 10.285 11.6504 10.9778 11.6504 11.8325C11.6504 12.6871 12.3432 13.38 13.1979 13.38Z",
			stroke: "#525059",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.88086 10.285V8.22167C2.88086 7.94805 2.98955 7.68565 3.18303 7.49217C3.3765 7.2987 3.63891 7.19 3.91253 7.19H12.1659C12.4395 7.19 12.7019 7.2987 12.8954 7.49217C13.0888 7.68565 13.1975 7.94805 13.1975 8.22167V10.285",
			stroke: "#525059",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.03955 4.09497V10.285",
			stroke: "#525059",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLevels);
export default ForwardRef;
